<template>
    <div class="pt-6">
      <b-form-checkbox class="p-6" v-model="currencyUSD"
       v-if="this.isMobileDevice == true" 
       value="value" >View in USD</b-form-checkbox>
          <b-table
            :items="data"
            :fields="fields"
            striped
            bordered
            head-variant="light"
            hover
            no-border-collapse
            show-empty
            :sticky-header="tableheight"
            :busy="isloading"
            foot-clone
            no-footer-sorting
            sort-icon-left
            responsive
            foot-variant="light" 
            style="float: right;"
          >
          <template #table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>
          <template #foot()="data">
            <span ></span>
          </template>
          <template #foot(period) v-if="!isloading">
            <span class="footerdata" >Total</span>
          </template>
          <template #foot(invoice_count)  v-if="!isloading">
            <span  class="footerdata" v-b-tooltip.hover :title="footerdata['invoice_count']">{{formatThousands(footerdata['invoice_count'])}}</span>
          </template>
          <template #foot(invoice_amount_aed)  v-if="!isloading">
            <span  class="footerdata" v-b-tooltip.hover :title="footerdata['invoice_amount_aed']">{{formatThousands(footerdata['invoice_amount_aed'])}}</span>
          </template>
          <template #foot(invoice_amount_usd)  v-if="!isloading">
            <span  class="footerdata" v-b-tooltip.hover :title="footerdata['invoice_amount_usd']">{{formatThousands(footerdata['invoice_amount_usd'])}}</span>
          </template>
          <template #foot(payment_count)  v-if="!isloading">
            <span  class="footerdata" v-b-tooltip.hover :title="footerdata['payment_count']">{{formatThousands(footerdata['payment_count'])}}</span>
          </template>
          <template #foot(payment_amount_aed)  v-if="!isloading">
            <span  class="footerdata" v-b-tooltip.hover :title="footerdata['payment_amount_aed']">{{formatThousands(footerdata['payment_amount_aed'])}}</span>
          </template>
          <template #foot(payment_amount_usd)  v-if="!isloading" >
            <span  class="footerdata" v-b-tooltip.hover :title="footerdata['payment_amount_usd']">{{formatThousands(footerdata['payment_amount_usd'])}}</span>
          </template>
          <!-- <template #cell()="data">
            <span class="right" >{{ data.value? formatThousands(data.value):0 }}</span>
          </template> -->
          <template  v-slot:cell()="data">
            <span class="right" v-b-tooltip.hover :title=data.value >{{ data.value? (data.field.key == 'period'? data.value: formatThousands(data.value)):0 }}</span>
          </template>
          <template  #head()="data">
            <span>{{ data.field.title.toUpperCase() }}</span>
          </template>
        
        </b-table>
    <!-- <paginator :disabled="disabled" :size="page_size" :total="total" /> -->
    <b-card no-body class="p-4 cardfont" v-if="!isloading && footerdata">
          <b-row>
            <b-col :cols="isMobileDevice == true? '2':'1'"><b>Total</b></b-col>
            <b-col>
              <b-row>
                <b-col :cols="isMobileDevice == true? '4':'3'">
                    <p>Invoices: {{footerdata['invoice_count']}}</p>
                    <p>Payments: {{footerdata['payment_count']}}</p>
                </b-col>
                <b-col :cols="isMobileDevice == true? '':'4'">
                    <p>Invoiced Volume(AED): {{formatTableCurrency(footerdata['invoice_amount_aed'])}}</p>
                    <p>Payments Volume(AED): {{formatTableCurrency(footerdata['payment_amount_aed'])}}</p>
                </b-col>
                <b-col v-if="!this.isMobileDevice == true"  :cols="isMobileDevice == true? '':'4'">
                    <p>Invoiced Volume(USD): {{formatTableCurrency(footerdata['invoice_amount_usd'])}}</p>
                    <p>Payments Volume(USD): {{formatTableCurrency(footerdata['payment_amount_usd'])}}</p>
                </b-col>
              </b-row>
            </b-col>
          </b-row>          
        </b-card>
    </div>
  </template>
  
  <script>
    import Paginator from "@/components/paginator.vue";
    import MonthlyDataService from '@/services/monthlydata.service';
    export default {
        components: {
        Paginator,
      },
        data() {
            return {
                isMobileDevice:false ,
                currencyUSD:false,
                isBusy: false,
                tableheight:"calc("+window.innerHeight+'px - 250px)',
                data:[],
                footerdata:{},
                fields: [
                    // {title: 'Index', key: 'id', sortable:true, showColumn: true},
                    { title: 'Period',key:'period', sortable: true },
                    { title: 'Invoices', key:'invoice_count',sortable: false },
                    { title: 'Invoiced Volume(AED)',key:'invoice_amount_aed',sortable: false},
                    { title: 'Invoiced Volume(USD)',key:'invoice_amount_usd',sortable: false },
                    { title: 'Payments',key:'payment_count', sortable: false },
                    { title: 'Payments Volume(AED)',key:'payment_amount_aed', sortable: false },
                    { title: 'Payments Volume(USD)', key:'payment_amount_usd',sortable: false },
                ],
            }
        },
        created(){
            let regexp = /android|iphone|kindle|ipad/i; 
            this.isMobileDevice = regexp.test(navigator.userAgent) || screen.width <= 600; 
            this.getMonthlydata();
        },
        methods: {
            getMonthlydata() {
                this.isloading = true
                MonthlyDataService.query()
                .then(({data}) => {
                    this.data = data.data
                    this.footerdata=data.total
                    if(this.isMobileDevice == true){
                      this.fields= [
                      // {title: 'Index', key: 'id', sortable:true, showColumn: true},
                      { title: 'Period',key:'period', sortable: true },
                      { title: 'Invoices', key:'invoice_count',sortable: false },
                      { title: 'Invoiced Volume(AED)',key:'invoice_amount_aed',sortable: false},
                      // { title: 'Invoiced Volume(USD)',key:'invoice_amount_usd',sortable: false },
                      { title: 'Payments',key:'payment_count', sortable: false },
                      { title: 'Payments Volume(AED)',key:'payment_amount_aed', sortable: false },
                      // { title: 'Payments Volume(USD)', key:'payment_amount_usd',sortable: false },
                      ];
                    }
                    this.isloading = false;
                    if(data.total['no_exchange_currencies'].length >0){
                      this.$showAlert('Exchange rates are not available for '+ data.total['no_exchange_currencies'].toString(),'danger');
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.$showAlert("Something went wrong!",'danger');
                  })
                .finally(() => {
                    this.isloading = false;
                });

            },
            formatTableCurrency(amount) {
              const formattedAmount = new Intl.NumberFormat("en-US", {
                style: "decimal",
                roundingIncrement: 5,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
                notation:'compact'
              }).format(amount);
              return formattedAmount
            },
            formatThousands(amount) {
              const formattedAmount = new Intl.NumberFormat("en-US", { 
                maximumFractionDigits: 2,
                minimumFractionDigits: 2,
                roundingIncrement: 5,
              }).format(amount);

              let splitAmount = formattedAmount.split(".");
              return splitAmount[0];  
           },
        },
        watch:{
          currencyUSD(newval) {
          if (newval) {
            this.fields= [
              // {title: 'Index', key: 'id', sortable:true, showColumn: true},
              { title: 'Period',key:'period', sortable: true },
              { title: 'Invoices', key:'invoice_count',sortable: false },
              // { title: 'Invoiced Volume(AED)',key:'invoice_amount_aed',sortable: false},
              { title: 'Invoiced Volume(USD)',key:'invoice_amount_usd',sortable: false },
              { title: 'Payments',key:'payment_count', sortable: false },
              // { title: 'Payments Volume(AED)',key:'payment_amount_aed', sortable: false },
              { title: 'Payments Volume(USD)', key:'payment_amount_usd',sortable: false },
              ];
          }
          else {
            this.fields= [
              // {title: 'Index', key: 'id', sortable:true, showColumn: true},
              { title: 'Period',key:'period', sortable: true },
              { title: 'Invoices', key:'invoice_count',sortable: false },
              { title: 'Invoiced Volume(AED)',key:'invoice_amount_aed',sortable: false},
              // { title: 'Invoiced Volume(USD)',key:'invoice_amount_usd',sortable: false },
              { title: 'Payments',key:'payment_count', sortable: false },
              { title: 'Payments Volume(AED)',key:'payment_amount_aed', sortable: false },
              // { title: 'Payments Volume(USD)', key:'payment_amount_usd',sortable: false },
              ];
          }
        },
        isMobileDevice(val){
          console.log(val);
          // this.tableheight= (val == true)?"600px": "500px";
        }
        
      }
    }
  </script>
  <style lang="scss">
    .footerdata {
      font-size: 18px;
      float:right;
    }
    .cardfont{
      font-size: 16px;
      bottom:0px;
    }
    @media (max-width: 990px) {
        .footerdata {
          font-size: 14px;
          float:right;
        }
        .cardfont{
          font-size: 12px;
        }
    }
    .right{
      float:right !important
    }
    
  </style>